/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaselineException
 */
export interface BaselineException {
    /**
     * 
     * @type {string}
     * @memberof BaselineException
     */
    exceptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineException
     */
    configItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineException
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineException
     */
    approvedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaselineException
     */
    approvedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineException
     */
    expirationDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineException
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaselineException
     */
    justification?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaselineException
     */
    compensatingControls?: Array<string>;
}

/**
 * Check if a given object implements the BaselineException interface.
 */
export function instanceOfBaselineException(value: object): value is BaselineException {
    return true;
}

export function BaselineExceptionFromJSON(json: any): BaselineException {
    return BaselineExceptionFromJSONTyped(json, false);
}

export function BaselineExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaselineException {
    if (json == null) {
        return json;
    }
    return {
        
        'exceptionId': json['exceptionId'] == null ? undefined : json['exceptionId'],
        'configItemId': json['configItemId'] == null ? undefined : json['configItemId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'approvedBy': json['approvedBy'] == null ? undefined : json['approvedBy'],
        'approvedAt': json['approvedAt'] == null ? undefined : (new Date(json['approvedAt'])),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'justification': json['justification'] == null ? undefined : json['justification'],
        'compensatingControls': json['compensatingControls'] == null ? undefined : json['compensatingControls'],
    };
}

export function BaselineExceptionToJSON(json: any): BaselineException {
    return BaselineExceptionToJSONTyped(json, false);
}

export function BaselineExceptionToJSONTyped(value?: BaselineException | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exceptionId': value['exceptionId'],
        'configItemId': value['configItemId'],
        'reason': value['reason'],
        'approvedBy': value['approvedBy'],
        'approvedAt': value['approvedAt'] == null ? undefined : ((value['approvedAt']).toISOString()),
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'isActive': value['isActive'],
        'justification': value['justification'],
        'compensatingControls': value['compensatingControls'],
    };
}

